import { BaseService } from "./BaseService";
import { Amenity } from "@/types/amenity";
import {
  IAmenitiesService,
  AmenitiesFilters,
  CreateAmenityDto,
  UpdateAmenityDto,
  AmenitiesFindAllResponse,
  ReorderAmenitiesDto,
  ReorderAmenitiesResponse,
} from "./interfaces/IAmenitiesService";

class AmenitiesService extends BaseService implements IAmenitiesService {
  private basePath = "/amenities";

  constructor() {
    super();
  }

  async getAll(filters?: AmenitiesFilters): Promise<AmenitiesFindAllResponse> {
    return this.get<AmenitiesFindAllResponse>(this.basePath, filters);
  }

  async getCategories(hotelId: string): Promise<string[]> {
    return this.get<string[]>(`${this.basePath}/categories`, { hotelId });
  }

  async getById(id: string): Promise<Amenity> {
    return this.get<Amenity>(`${this.basePath}/${id}`);
  }

  async create(data: CreateAmenityDto): Promise<Amenity> {
    return this.post<Amenity>(this.basePath, data);
  }

  async update(id: string, data: UpdateAmenityDto): Promise<Amenity> {
    return this.patch<Amenity>(`${this.basePath}/${id}`, data);
  }

  async reorder(data: ReorderAmenitiesDto): Promise<ReorderAmenitiesResponse> {
    return this.post<ReorderAmenitiesResponse>(
      `${this.basePath}/reorder`,
      data,
    );
  }

  async deleteAmenity(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }
}

export const amenitiesService = new AmenitiesService();
